 <template>
<div class="grid dashboard">	
	<div class="col-12 md:col-2 pl-0 pb-0" v-for="item in lstEquiposPorTipo" :key="item.ID" >
		<div class="w-full" :class="'overview-box-'+ util.limpiarCadena(item.TIPO)">
				<div class="w-full" @click="mostrarEquipos(item.TIPO)">
					<div class="col-12">
						<p class="title">{{item.TIPO.toLowerCase()}}</p>
					</div>
					<div class="grid col-12 res">
						<div class="col-6">
							<p class="value">{{item.EQUIPOS}}</p>
						</div>
						<div class="col-6 flex align-items-center justify-content-end">
							<img class="img" :src="'/assets/' + util.limpiarCadena(item.TIPO) + '.png'"/>
						</div>
					</div>
				</div>
			<!-- <div class="col-12 title">
			</div>
			<div class="col-12 value">
			</div>		 -->
		</div>
		
	</div>
		

</div>

</template>

<script>
import Srvr from '../service/Inventario'
import {mapGetters} from 'vuex'
import Utilerias from '../utilidades/Utilerias'
export default {
	data() {
		return {	
			lstUnidades: [],
			selectedUnidadFiltro: null,
			lstEquiposPorTipo:null,
			loading: true,
			filters: {},		
			util : new Utilerias(),			
		}
	},
	created() {
		
	},
	mounted() {
		var t = this;		
		t.cargaDashboard();		
	},
	methods: {
		mostrarEquipos(tipo){
			if(tipo != "Referencias"){
				this.$router.push({path: `/universo/${tipo}`});
			}else{
				this.$router.push({name: 'referencias'});
			}
		},
		formateaFechaAMD(fecha){
			
			var anio = fecha.getFullYear();
			var mes = fecha.getMonth() + 1;
			var dia = fecha.getDate();

			return anio + "-" + mes + "-" + dia;
			
		},
		formatNumber(value) {
			if(value){								
				return new Intl.NumberFormat('en-US').format(value);
			}
			else
				return 0;
		},
		formatCurrency(value) {
			if(value){				
				var formatter = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',					
					});
				return formatter.format(value);
			}
			else
				return 0;
		},
		cargaDashboard(){
			var t = this;
			var ctlSvr = new Srvr;
			// ctlSvr.getUnidades(t).then(res =>{
			// 	//console.log(res);
			// 	t.lstUnidades = res;
			// 	t.lstUnidades.unshift({ UNIDAD: "TODOS",SUBRED: "TODOS", UNIDAD_SUBRED: "TODOS" });
			// });
			ctlSvr.getEquiposPorTipo(t).then(res =>{
				//console.log(res);
				t.lstEquiposPorTipo = res;
				t.loading =false;
			});
		},		
	},
	computed: {	
        ...mapGetters(['getUsuarioLogueado']),    
		totalBienes() {
			return parseInt(this.datosIMSSR.BIENES) + parseInt(this.datosIMSSP.BIENES);
		},
		montoTotalBienes() {
			return parseFloat(this.datosIMSSR.TOTAL) + parseFloat(this.datosIMSSP.TOTAL);
		}
	}
}
</script>

<style lang="scss" scoped>
	@media screen and (max-width: 960px) {
		.p-datatable {
			&.p-datatable-customers {
				.p-datatable-thead > tr > th,
				.p-datatable-tfoot > tr > td {
					display: none !important;
				}

				.p-datatable-tbody > tr {
					border-bottom: 1px solid #dee2e6;
					> td {
						text-align: left;
						display: flex;
						align-items: center;
						justify-content: center;
						border: 0 none !important;
						width: 100% !important;
						float: left;
						clear: left;
						border: 0 none;

						.column-title {
							padding: .4rem;
							min-width: 30%;
							display: inline-block;
							margin: -.4rem 1rem -.4rem -.4rem;
							font-weight: bold;
						}

						.p-progressbar {
							margin-top: .5rem;
						}
					}
				}
			}
		}
	}
</style>
